import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.416 1.917H5.583A4.59 4.59 0 0 0 1 6.5v7.333a4.59 4.59 0 0 0 4.583 4.583h5.5v1.834H7.416a.916.916 0 1 0 0 1.833h9.167a.916.916 0 1 0 0-1.833h-3.667v-1.834h5.5A4.59 4.59 0 0 0 23 13.833V6.5a4.59 4.59 0 0 0-4.584-4.583m2.75 11.916a2.75 2.75 0 0 1-2.75 2.75H5.583a2.75 2.75 0 0 1-2.75-2.75V6.5a2.75 2.75 0 0 1 2.75-2.75h12.833a2.75 2.75 0 0 1 2.75 2.75zm-1.833-3.667a.916.916 0 0 1-.917.917h-2.718l-1.558 2.342a.92.92 0 0 1-.765.408h-.057a.92.92 0 0 1-.764-.505l-2.043-4.09-.957 1.437a.92.92 0 0 1-.763.408H5.583a.916.916 0 1 1 0-1.833h2.718l1.558-2.342a.9.9 0 0 1 .823-.408.92.92 0 0 1 .763.505l2.043 4.087.957-1.436a.92.92 0 0 1 .763-.406h3.208a.916.916 0 0 1 .917.916"
    }, null, -1)
  ]))]))
}
export default { render: render }